'use strict';

var InitSelectPicker = {
    initSelectpicker: function () {
        $('.selectpicker').selectpicker();

        if (/Android|webOS|BlackBerry/i.test(navigator.userAgent)) {
            $('.selectpicker').not('.with-ajax').selectpicker('mobile');
        }
    },

    init: function () {
        this.initSelectpicker();
    }
};

$(document).ready(function () {
    InitSelectPicker.init();
});